import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'

export const createLocationEntity = (
  locationId: number | string,
  locations: Array<{ id: number | string; name: string }>
): EntitySelectEntity => {
  const location = locations.find((loc) => Number(loc.id) === Number(locationId))
  return {
    id: Number(locationId),
    name: location?.name ?? '',
  }
}

export const createLocationEntities = (
  locationIds: Array<number | string>,
  locations: Array<{ id: number | string; name: string }>
): EntitySelectEntity[] => {
  return locationIds.map((id) => createLocationEntity(id, locations))
}
